import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SUCCESS } from 'utils/constants/queryStatuses';
import { Skeleton } from 'components/Skeleton';
import {
  PopupTitle, PopupContent, PopupSubtitle, PopupButton,
} from 'new-ui/Components/Popup';
import app from 'new-ui/app';
import { useTranslation } from 'utils/modifiedTranslation';
import { FORM_THEMES } from 'new-ui/Components/Form';
import { CheckboxNew } from 'components/Checkbox';
import { getUserWixId } from 'modules/user/utils';

const UNSUBSCRIBE_PROPERTIES = {
  EMAIL: 'unsubscribed_from_emails',
  SMS: 'unsubscribed_sms',
};

const UnsubscribeForm = ({ closePopup }) => {
  const { t } = useTranslation();
  const {
    status: appConfigurationStatus,
    userConfiguration,
  } = useSelector((state) => state.appConfiguration);
  const profile = useSelector((state) => state.profile.data);

  const emailSelectedConfiguration = userConfiguration[UNSUBSCRIBE_PROPERTIES.EMAIL] || false;
  const smsSelectedConfiguration = userConfiguration[UNSUBSCRIBE_PROPERTIES.SMS] || false;

  const [emailSelected, setEmailSelected] = useState(emailSelectedConfiguration || null);
  const [smsSelected, setSmsSelected] = useState(smsSelectedConfiguration || null);

  useEffect(() => {
    if (appConfigurationStatus !== SUCCESS || emailSelected !== null) {
      return;
    }
    setSmsSelected(smsSelectedConfiguration);
    setEmailSelected(emailSelectedConfiguration);
  }, [emailSelectedConfiguration, appConfigurationStatus, emailSelected, smsSelectedConfiguration]);

  const save = () => {
    const data = {
      [UNSUBSCRIBE_PROPERTIES.EMAIL]: emailSelected,
      [UNSUBSCRIBE_PROPERTIES.SMS]: smsSelected,
    };

    app.updateUserConfiguration(data);
    app.intercom.updateUserAttributes(data, getUserWixId(profile));

    closePopup();
  };

  if (appConfigurationStatus !== SUCCESS) {
    return (
      <PopupContent>
        <Skeleton width="100%" height="150px" />
      </PopupContent>
    );
  }

  return (
    <PopupContent>
      <div className="unsubscribe_form">
        <PopupTitle title={t('unsubscribe_form_popup.title')} />
        <PopupSubtitle subtitle={t('unsubscribe_form_popup.question.email')} />
        <CheckboxNew
          key="email"
          theme="default"
          label="Unsubscribe from emails"
          checked={emailSelected}
          onChange={(event) => setEmailSelected(event.target.checked)}
        />
        <CheckboxNew
          key="sms"
          theme={FORM_THEMES.ORANGE}
          label="Unsubscribe from sms"
          checked={smsSelected}
          onChange={(event) => setSmsSelected(event.target.checked)}
        />
      </div>
      <PopupButton title={t('unsubscribe_form_popup.btn')} action={save} />
    </PopupContent>
  );
};

UnsubscribeForm.propTypes = {
  closePopup: PropTypes.func.isRequired,
};

export default UnsubscribeForm;
